import { render, staticRenderFns } from "./TelegramSettings.vue?vue&type=template&id=85c0df8c"
import script from "./TelegramSettings.vue?vue&type=script&lang=js"
export * from "./TelegramSettings.vue?vue&type=script&lang=js"
import style0 from "./TelegramSettings.vue?vue&type=style&index=0&id=85c0df8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports